<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding: 8px;

    .avatar {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: colors.get(primary_10);
      color: colors.get(primary_50);

      width: 24px;
      height: 24px;
      border-radius: 20px;

      &.processing {
        background-color: colors.get(interfaceSwGrey_10);
        color: colors.get(interfaceSwGrey_20);
      }
    }
  }
</style>

<script>
  import Icon from "@sourcewhale/shared/svelte-design-system/components/atoms/Icon.svelte";

  let { status } = $props();

  const avatarColor = $derived(
    status === "processing" ? "interfaceSwGrey_20" : "primary_50"
  );
</script>

<div class="icon-container">
  {#if status === "error"}
    <Icon class="fa-regular fa-exclamation-circle color-systemError_100" />
  {:else}
    <div class="avatar {status}">
      <Icon class={`fa-solid fa-user color-${avatarColor}`} size="xs" />
    </div>
  {/if}
</div>
